/* eslint-disable max-len */
import { DatabaseScheme } from './constants';

export const databaseSchemeRequest = (data, callback) => ({ type: DatabaseScheme.databaseSchemeRequest, data, callback });
export const databaseSchemeSuccess = (data) => ({ type: DatabaseScheme.databaseSchemeSuccess, data });
